'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgArrowExpand = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M8 6.243 12.243 2l4.242 4.243V9.07L13.24 5.825 13.254 11h-2.008V5.825L8 9.071V6.243ZM8 17.657l4.243 4.242 4.242-4.242v-2.829l-3.245 3.246.007-5.074h-2.008l.007 5.074L8 14.828v2.829Z" })
);

module.exports = SvgArrowExpand;
//# sourceMappingURL=ArrowExpand.cjs.js.map
